import { render, staticRenderFns } from "./RiskSidePanel.vue?vue&type=template&id=25d4ca70&scoped=true"
import script from "./RiskSidePanel.vue?vue&type=script&lang=js"
export * from "./RiskSidePanel.vue?vue&type=script&lang=js"
import style0 from "./RiskSidePanel.vue?vue&type=style&index=0&id=25d4ca70&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d4ca70",
  null
  
)

export default component.exports